<template>
  <div>
    <div
      class="w-full pb-1 truncate text-grey-darker font-semibold"
      v-if="placeholder.length != 0"
    >
      <label v-text="placeholder" v-bind:for="name"></label>
      <span
        v-show="
          required ||
          this.type == 'account_number' ||
          this.type == 'serial_number'
        "
        class="text-red"
        >*</span
      >
    </div>
    <div
      v-bind:class="[border]"
      class="border rounded overflow-hidden flex flex-row"
    >
      <div
        v-show="isMobile()"
        v-text="phcode"
        class="text-grey-dark text-sm px-2 border-r font-bold papsi-txt-lh"
      ></div>
      <div class="flex-grow">
        <input
          v-model="val"
          v-bind:id="name"
          v-bind:type="current_type"
          v-bind:maxlength="max"
          v-bind:disabled="disabled || loading"
          v-bind:class="{ uppercase: uppercase, 'text-center': center }"
          v-on:focus="focus"
          v-on:blur="blur"
          :max="maxDate"
          :min="minDate"
          ref="textbox"
          class="w-full p-3 outline-none text-sm border-none"
          autocomplete="off"
          spellcheck="false"
          @input="onInput"
        />
      </div>
      <div
        v-show="isPassword() && strength && val.length != 0"
        class="text-xs font-bold flex justify-content items-center break-keep"
      >
        <span v-bind:class="[color]" v-text="score"></span>
      </div>
      <div v-show="isPassword() && !nohint" class="px-2">
        <img
          v-bind:src="getIcon()"
          v-on:click="toggle"
          class="w-icon h-icon papsi-icon-mt"
        />
      </div>
      <img
        v-if="this.loading"
        class="w-icon h-icon papsi-icon-mt mr-2"
        src="@/assets/icons/papsi_spinner.svg"
      />
      <img
        v-else-if="
          (is_taken.email !== null && is_taken.email) ||
          (is_taken.username !== null && is_taken.username) ||
          (is_taken.mobile !== null && is_taken.mobile)
        "
        class="w-icon h-icon papsi-icon-mt mr-2"
        src="@/assets/icons/papsi_exit_red.svg"
      />
      <img
        v-else-if="
          (is_taken.email !== null && !is_taken.email) ||
          (is_taken.username !== null && !is_taken.username) ||
          (is_taken.mobile !== null && !is_taken.mobile)
        "
        class="w-icon h-icon papsi-icon-mt mr-2"
        src="@/assets/icons/papsi_check.svg"
      />
    </div>
    <span v-if="error_message" class="text-xs text-error">{{
      error_message
    }}</span>
  </div>
</template>

<script>
import { passwordStrength } from "check-password-strength";
import User from "@/services/User";
import mixin from "@/mixin";

export default {
  name: "v-text",
  mixins: [mixin],
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxlength: {
      type: Number,
      default: null,
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    nohint: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    strength: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    alphanumeric: {
      type: Boolean,
      default: false,
    },
    registration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current_type: "text",
      border: "border-grey",
      val: "",
      visible: false,
      max: null,
      phcode: "+63",
      score: "",
      color: null,
      colors: ["text-red", "text-red-lighter", "text-yellow", "text-green"],
      loading: false,
      error_message: null,
      is_taken: {
        email: null,
        mobile: null,
        username: null,
      },
    };
  },
  computed: {
    formattedValue() {
      if (this.type === "date_of_birth") {
        return this.formatToDateString(this.val || this.value);
      }
      return this.val;
    },
    maxDate() {
      if (this.type === "date_of_birth") {
        const now = new Date();
        now.setFullYear(now.getFullYear() - 18);

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      }
      return null;
    },
    minDate() {
      if (this.type === "date_of_birth") {
        return "1900-01-01";
      }
      return null;
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.max = 10;
      this.current_type = "text";
    } else if (this.type == "date_of_birth") {
      this.current_type = "date";
    } else {
      this.max = this.maxlength;
    }

    if (this.isPassword()) {
      this.current_type = "password";
    }
  },
  methods: {
    onInput(e) {
      let value = e.target.value;

      if (
        this.type == "username" ||
        // this.type == "login_username" ||
        this.type == "account_number"
      ) {
        value = this.filterLetters(value);
      } else if (this.type == "mobile") {
        value = this.filterTIN(value);
      } else if (this.type == "serial_number") {
        value = this.filterSerial(value);
      } else if (this.type == "tin") {
        value = this.filterTIN(value);
      }

      if (this.max && value.length > this.max) {
        value = value.slice(0, this.max);
      }

      this.val = value;
    },
    formatToDateString(date) {
      if (!date) return "";

      if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }

      const parsed_date = new Date(date);
      if (isNaN(parsed_date)) return "";

      const year = parsed_date.getFullYear();
      const month = String(parsed_date.getMonth() + 1).padStart(2, "0");
      const day = String(parsed_date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    filterLetters(value) {
      return value.replace(/[^a-zA-Z0-9_]/g, "");
    },
    filterSerial(value) {
      let cleaned = value.replace(/[^a-zA-Z0-9-]/g, "");

      const dash_index = cleaned.indexOf("-");
      if (dash_index !== -1) {
        cleaned =
          cleaned.slice(0, dash_index + 1) +
          cleaned.slice(dash_index + 1).replace(/-/g, "");
      }

      return cleaned;
    },
    filterNumbers(value) {
      return value.replace(/[^0-9]/g, "");
    },
    filterTIN(value) {
      return value.replace(/[^0-9-]/g, "");
    },
    isEmailValid(value) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(value);
    },
    isMobileValid(value) {
      const regex = /^9\d{9}$/;
      return regex.test(value);
    },
    isEmailTaken(value) {
      if (value.length > 0) {
        this.is_taken.email = null;
        this.error_message = null;
        this.loading = true;
        this.$emit("validating", true);
        User.checkEmailAvailability(value)
          .then(() => {
            this.is_taken.email = false;
            this.border = "border-grey";
            this.error_message = null;
            this.$emit("is-valid", true);
          })
          .catch(() => {
            this.is_taken.email = true;
            this.border = "border-red-light";
            this.error_message = this.lang("lbl_0000239");
            this.$emit("is-valid", false);
          })
          .finally(() => {
            this.loading = false;
            this.$emit("validating", false);
          });
      }
    },
    isUsernameTaken(value) {
      if (value.length > 0) {
        this.is_taken.username = null;
        this.error_message = null;
        this.loading = true;
        this.$emit("validating", true);
        User.checkUsernameAvailability(value)
          .then(() => {
            this.is_taken.username = false;
            this.border = "border-grey";
            this.error_message = null;
            this.$emit("is-valid", true);
          })
          .catch(() => {
            this.is_taken.username = true;
            this.border = "border-red-light";
            this.error_message = this.lang("lbl_0000241");
            this.$emit("is-valid", false);
          })
          .finally(() => {
            this.loading = false;
            this.$emit("validating", false);
          });
      }
    },
    isMobileTaken(value) {
      if (value.length > 0) {
        this.is_taken.mobile = null;
        this.error_message = null;
        this.loading = true;
        this.$emit("validating", true);
        User.checkMobileAvailability(value)
          .then(() => {
            this.is_taken.mobile = false;
            this.border = "border-grey";
            this.error_message = null;
            this.$emit("is-valid", true);
          })
          .catch(() => {
            this.is_taken.mobile = true;
            this.border = "border-red-light";
            this.error_message = this.lang("lbl_0000249");
            this.$emit("is-valid", false);
          })
          .finally(() => {
            this.loading = false;
            this.$emit("validating", false);
          });
      }
    },
    focus() {
      this.border = "border-primary";

      this.$emit("focus", {
        name: this.name,
        value: this.val,
      });
    },
    blur() {
      if (this.type === "email") {
        if (!this.isEmailValid(this.value)) {
          this.setError("lbl_0000242");
          return;
        }
        if (this.registration) {
          this.isEmailTaken(this.value);
        } else {
          this.clearError();
          this.is_taken.email = null;
        }
      } else if (this.type === "username") {
        if (this.value.length < 6) {
          this.setError("lbl_0000243");
          return;
        }
        if (this.registration) {
          this.isUsernameTaken(this.value);
        } else {
          this.clearError();
          this.is_taken.username = null;
        }
      } else if (this.type === "mobile") {
        if (!this.isMobileValid(this.value)) {
          this.setError("lbl_0000240");
          return;
        }
        if (this.registration) {
          this.isMobileTaken(this.value);
        } else {
          this.is_taken.mobile = null;
          this.clearError();
        }
      } else {
        if (this.value.length > 0 || !this.required) {
          this.border = "border-grey";
        } else {
          this.border = "border-red-light";
        }
      }
      this.$emit("blur", {
        name: this.name,
        value: this.val,
      });
    },
    isMobile() {
      return this.type.toLowerCase() == "mobile";
    },
    isPassword() {
      return this.type.toLowerCase() == "password";
    },
    toggle() {
      this.visible = !this.visible;
      this.current_type = this.visible ? "text" : "password";
      this.$refs.textbox.focus();
    },
    getIcon() {
      return require(this.visible
        ? "@/assets/icons/papsi_password_visible.svg"
        : "@/assets/icons/papsi_password_invisible.svg");
    },
    setError(message) {
      this.error_message = this.lang(message);
      this.border = "border-red-light";
    },
    clearError() {
      this.border = "border-grey";
      this.error_message = null;
    },
  },
  watch: {
    val(val) {
      if (this.isPassword()) {
        let test = passwordStrength(val);

        this.color = this.colors[test.id];
        this.score = test.value.toLowerCase();

        this.$emit("strong", test.id >= 2);
      }

      this.$emit("typing", {
        name: this.name,
        value: val,
      });
    },
    value(val) {
      this.val = val;
    },
    type(type) {
      this.current_type = type;
    },
    maxlength(n) {
      this.max = n;
    },
  },
};
</script>

<style scoped>
.papsi-icon-mt {
  margin-top: 7px;
}

.papsi-txt-lh {
  line-height: 40px;
}
</style>
